class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.endDate = new Date(this.dataset.endDate);
  }

  connectedCallback() {
    this.updateCountdown();
    this.timer = setInterval(this.updateCountdown.bind(this), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const timeLeft = this.endDate.getTime() - now;

    if (timeLeft <= 0) {
      clearInterval(this.timer);
      this.displayTime(0, 0, 0, 0);
      return;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    this.displayTime(days, hours, minutes, seconds);
  }

  displayTime(days, hours, minutes, seconds) {
    this.querySelector('#days').innerHTML = String(days).padStart(2, '0');
    this.querySelector('#hours').innerHTML = String(hours).padStart(2, '0');
    this.querySelector('#minutes').innerHTML = String(minutes).padStart(2, '0');
    this.querySelector('#seconds').innerHTML = String(seconds).padStart(2, '0');
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
